import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TimeScanningService } from "../../../shared/data.service";

@Component({
	selector: "caass-manual-selector-extended-info",
	templateUrl: "./manual-selector-extended-info.component.html",
	styleUrls: ["./manual-selector-extended-info.component.css"],
})
export class ManualSelectorExtendedInfoComponent implements OnInit {
	constructor(private scanService: TimeScanningService) {}

	ngOnInit(): void {
		this.loadPersonData();
	}

	ngOnChanges() {
		this.loadPersonData();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	@Input() AudienceMode: string = "Student";
	@Input() SelectedPerson: any;
	@Input() FacilityID: any;

	// Don't Reload more than once
	PersonExtended: any = null;

	Loading: boolean = false;

	PersonTypeID: any = -1;
	PhotoData: string = "";
	FirstName: string = "";
	LastName: string = "";
	DesignatorID: string = "";
	StaffTitle: string = "";
	Status: string = "";
	FineOwed: string = "";
	TardyMTD: string = "";
	AbsentMTD: string = "";
	CutsMTD: string = "";
	SchoolNBR: string = "";
	Homeroom: string = "";
	Academy: string = "";
	Grade: string = "";
	InSchool: string = "";
	SecondaryStatus: string = "";

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////

	loadPersonData() {
		this.ClearData();

		if (this.SelectedPerson == null) {
			return;
		}

		this.Loading = true;

		this.FirstName = this.SelectedPerson.FirstName;
		this.LastName = this.SelectedPerson.LastName;
		this.DesignatorID = this.SelectedPerson.ID;

		var result = this.scanService.ScanPointManualExtendedSelect(this.SelectedPerson.PersonID, this.FacilityID);
		result.subscribe(
			(response: any) => {
				this.PersonExtended = response;
				this.UpdateData();

				// this.PersonExtendedSelected.emit(response);

				this.Loading = false;
			},
			(error) => {
				this.Loading = false;
			}
		);
	}

	UpdateData() {
		this.PersonTypeID = this.PersonExtended.PersonTypeID == null ? -1 : this.PersonExtended.PersonTypeID;
		this.PhotoData = this.PersonExtended.PhotoData == null ? "" : this.PersonExtended.PhotoData;
		this.FirstName = this.PersonExtended.FirstName == null ? "" : this.PersonExtended.FirstName;
		this.LastName = this.PersonExtended.LastName == null ? "" : this.PersonExtended.LastName;
		this.DesignatorID = this.PersonExtended.DesignatorID == null ? "" : this.PersonExtended.DesignatorID;
		this.StaffTitle = this.PersonExtended.StaffTitle == null ? "" : this.PersonExtended.StaffTitle;
		this.Status = this.PersonExtended.Status == null ? "" : this.PersonExtended.Status;
		this.FineOwed = this.PersonExtended.FineOwed == null ? "" : "$" + Number(this.PersonExtended.FineOwed).toFixed(2);
		this.TardyMTD = this.PersonExtended.TardyMTD == null ? "" : this.PersonExtended.TardyMTD;
		this.AbsentMTD = this.PersonExtended.AbsentMTD == null ? "" : this.PersonExtended.AbsentMTD;
		this.CutsMTD = this.PersonExtended.CutsMTD == null ? "" : this.PersonExtended.CutsMTD;
		this.SchoolNBR = this.PersonExtended.SchoolNBR == null ? "" : this.PersonExtended.SchoolNBR;
		this.Homeroom = this.PersonExtended.Homeroom == null ? "" : this.PersonExtended.Homeroom;
		this.Academy = this.PersonExtended.Academy == null ? "" : this.PersonExtended.Academy;
		this.Grade = this.PersonExtended.Grade == null ? "" : this.PersonExtended.Grade;
		this.InSchool = this.PersonExtended.InSchool == null ? "" : this.PersonExtended.InSchool;
		this.SecondaryStatus = this.PersonExtended.SecondaryStatus == null ? "" : this.PersonExtended.SecondaryStatus;
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////
	PersonSelected() {
		return this.SelectedPerson != null;
	}

	IsStudent() {
		if (this.SelectedPerson == null) {
			return false;
		} else {
			return this.PersonTypeID == 1;
		}
	}

	ClearData() {
		this.PersonTypeID = -1;
		this.PhotoData = "";
		this.FirstName = "";
		this.LastName = "";
		this.DesignatorID = "";
		this.StaffTitle = "";
		this.Status = "";
		this.FineOwed = "";
		this.TardyMTD = "";
		this.AbsentMTD = "";
		this.CutsMTD = "";
		this.SchoolNBR = "";
		this.Homeroom = "";
		this.Academy = "";
		this.Grade = "";
		this.InSchool = "";
		this.SecondaryStatus = "";
	}
	/////////////////////////////////////////////////////////////////
}
